// extracted by css-extract-rspack-plugin
export default {"wrapper":"wrapper-X4z3zj","withBusinessSwitchMargin":"withBusinessSwitchMargin-AlNfVq"};